import React from "react";

type Props = {};

const Investment80CHint: React.FC<Props> = (props: Props) => {
  return (
    <>
      <p className="leading-para text-greyDark mb-4">
        You should claim the entire 80C amount, even if you forgot to submit investment proofs for
        80C to your HR. Even if your Form 16 does not have the total 80C amount, you can claim right
        now. Just keep your investment proofs with yourself safely.
      </p>
      <p className="leading-para text-greyDark mb-4">
        If you changed jobs, remember to add EPF contribution from all your employers in 80C. EPF is
        employee provident fund.
      </p>
      <p className="leading-para text-greyDark">
        80C: PPF (Public Provident Fund), Sukanya Samridhi, ULIPs, Insurance premium, Five year
        fixed deposits, Postal deposits, ELSS Mutual Funds are eligible for 80C. Children school
        fees, payment of principal of housing loan is also eligible.
      </p>
    </>
  );
};

export default Investment80CHint;
